import React, { useEffect, useLayoutEffect, useState } from "react";
import { useAuth } from "../../../../modules/auth";
import DetallesTestimonio from "../../../Testimonial/EntrevistaIndividual/detallesTestimonio";
import AudioPlayer from "./audioplayer";
import { IFile, ITestimonio, createTestimonio } from "./testimonioModel";
import { useParams } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL
const auth = JSON.parse(localStorage.getItem("kt-auth-react-v")!);


const TranscripcionVisor : React.FC = () => {
  const { nombre } = useParams<{ nombre: string }>(); 
  const { nombreOriginal } = useParams<{ nombreOriginal: string }>(); 

  const [transcripcion, setTranscripcion] = useState<string>();
  const [contenidoArchivo, setContenidoArchivo] = useState<string>('Cargando...');
  const [token, setToken] = useState<any | null>(null);  // Estado para almacenar el token

  useEffect(() => {
    const downloadFile = async () => {

      try {
        const response = await fetch(`${API_URL}/files/getfile/${nombre}/${nombreOriginal}`, {
          headers: {
            'Content-Type': "text/plain",
            'auth-token': auth.api_token,
          }
        });

        if (!response.ok) {
          throw Error(response.statusText);
        }

        const texto = await response.text();
        setContenidoArchivo(texto);
      } catch (err) {
        console.error(err);
        setContenidoArchivo('Error al cargar el archivo');
      }
    };

    downloadFile();
  }, [nombre, nombreOriginal, token]);

 

  return ( 
    <>
    {contenidoArchivo ? (
      <>
        <h1>{nombreOriginal}</h1>
        <div>
          <textarea>{contenidoArchivo}</textarea>
        </div>
      </>
    ): (<></>)}
    </>
  )
}

export default TranscripcionVisor;